import {
  type Certificate,
  type Company,
  type CertificateInstance,
  type CertificateStatus,
  type CertificateStatusesExpired,
  type EnrichedCertificate,
} from '../Store/DataSlice'

export function webWorkerCalculateEnrichedCertificates({
  certificates,
  companies,
  certificateInstances,
}: {
  certificates: Certificate[]
  companies: Company[]
  certificateInstances: CertificateInstance[]
}) {
  const dateNow = Date.now()
  // copy of src\Utils\Formatting.ts > calculateCertificateActualStatus for webWorker optimization
  const calculateCertificateActualStatus = (
    certificate: Certificate | undefined
  ): CertificateStatus | CertificateStatusesExpired | '' => {
    if (certificate === undefined) return ''
    if (certificate.status !== 'Valid' && certificate.status !== 'Prolonged')
      return certificate.status
    if (
      certificate.validFrom <= dateNow &&
      (certificate.status === 'Prolonged' &&
      certificate.extendedUntil !== undefined
        ? certificate.extendedUntil
        : certificate.validUntil) >= dateNow
    )
      return certificate.status
    return 'Expired'
  }

  const enrichedCertificates = certificates.map<EnrichedCertificate>(
    (certificate) => {
      const relatedCompanies = companies.filter((c) =>
        certificate.companyBranches?.some((v) => v.vatNumber === c.vatNumber)
      )
      return {
        ...certificate,
        calculatedStatus: calculateCertificateActualStatus(certificate),
        companyNames:
          companies.length === 0
            ? '...'
            : relatedCompanies.map((c) => c.name).join(', '),
        companyPostcodes:
          companies.length === 0
            ? '...'
            : relatedCompanies.map((c) => c.postalCode).join(' '),
        certificateInstanceName:
          certificateInstances.length === 0
            ? '...'
            : certificateInstances.find(
                (ci) =>
                  ci.vatNumber === certificate.certificateInstanceVatNumber
              )?.name ?? '',
      }
    }
  )
  postMessage(enrichedCertificates)
}
